import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import type { AuthFormPanelProps } from './auth-layout.interface'

export const AuthFormPanel: React.FC<AuthFormPanelProps> = ({
  children,
  headerSlot,
  className,
}): ReactNode => (
  <div
    className={cn(
      'auth-form-panel flex flex-col items-center justify-start px-3 py-10 sm:px-6 lg:justify-center lg:p-12',
      className
    )}
  >
    {headerSlot}
    <div className="auth-form-card w-full max-w-md rounded-2xl bg-[linear-gradient(135deg,#1f1f1f,#2f2f2f)] p-1.5 shadow-2xl">
      <div className="rounded-xl bg-white px-2 py-4">{children}</div>
    </div>
  </div>
)
